import { useCallback } from 'react';
import { getQueryClientV2 } from '@/src/v2/service/v2/graphql/apiv2';

export const useAppService = () => {
  const getApiService = useCallback(() => {
    return getQueryClientV2();
  }, []);

  return {
    getApiService,
  };
};
